import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

const TopFavoriteBannerStyles = styled.div`
  width: 324px;
  height: 68px;
  border: 1px solid ${Colors.accent.grey5.standard};

  margin-top: 20px;

  display: flex;
  align-items: center;

  h5,
  p {
    color: ${Colors.primary.claytonBlue.standard};
  }

  .top-favorite-home {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    .top-favorite-text {
      width: 258px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .remove {
        cursor: pointer;
      }
    }
  }

  .top-favorite-removed {
    width: 100%;
    display: flex;
    justify-content: center;
    .top-favorite-text {
      width: 258px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    svg {
      height: 20px;
      width: 20px;
      margin-right: 2px;

      * {
        fill: ${Colors.primary.claytonBlue.standard};
      }
    }
  }
`;

export default TopFavoriteBannerStyles;
